import {
  ClientPaymentStatus,
  getTimeZone,
  lightTheme,
} from '@vgrubs/components';
import { DateTime } from 'luxon';

export type SaasRange = { from: string; to: string; timeZone: string };

/**
 * The overview's own range params, so the details add up to the "Monthly
 * Saas" the arrow was clicked on: whole days, in the browser's time zone.
 */
export const saasRange = (from: string, to: string): SaasRange => ({
  from: DateTime.fromISO(from).startOf('day').toISODate() || '',
  to: DateTime.fromISO(to).endOf('day').toISODate() || '',
  timeZone: getTimeZone,
});

// String keys rather than the enum's members: a barrel value read at module
// level is undefined in an eagerly loaded file.
export const SAAS_STATUS_LABEL: Record<ClientPaymentStatus, string> = {
  completed: 'Completed',
  initiated: 'Initiated',
  failed: 'Failed',
  chargedBack: 'Charged Back',
  cancelled: 'Cancelled',
};

/** Green for money in, gray for on its way or called off, red for a problem. */
export const saasStatusColor = (status: ClientPaymentStatus) => {
  switch (status) {
    case ClientPaymentStatus.completed:
      return lightTheme.green;
    case ClientPaymentStatus.failed:
    case ClientPaymentStatus.chargedBack:
      return lightTheme.primary;
    case ClientPaymentStatus.initiated:
      return lightTheme.darkGray;
    default:
      return lightTheme.lightGray;
  }
};

/**
 * The billed period. Its bounds are UTC month boundaries, so they are read in
 * UTC: in New York the first of the month would come out as the 30th or 31st.
 */
export const formatBilledPeriod = (
  fromDate: string | null,
  toDate: string | null
) => {
  if (!fromDate || !toDate) return '-';
  const format = (iso: string) =>
    DateTime.fromISO(iso, { zone: 'utc' }).toFormat('MMM dd, yyyy');
  return `${format(fromDate)} - ${format(toDate)}`;
};
